export const useUIVerification = () => {
  const uiIsPhoneVerified = ref<boolean>(false);

  const { studentRoles } = useAuth();

  const isUserPhoneVerified = computed(() => {
    const roles = studentRoles.value.filter(role => role.isPhoneNumberProvidedAndVerified);
    return roles.length > 0;
  });

  const userPhoneNumber = computed(() => {
    const roleWithPhoneNumber = studentRoles.value.filter(role => !!role.phoneNumber) ?? [];
    if (roleWithPhoneNumber[0] && roleWithPhoneNumber[0].phoneNumber) {
      return roleWithPhoneNumber[0].phoneNumber;
    }
    return '';
  });

  const verificationUIReady = ref(false);
  onMounted(() => {
    verificationUIReady.value = true;
  });

  watch(isUserPhoneVerified, () => {
    uiIsPhoneVerified.value = isUserPhoneVerified.value;
  }, { immediate: true });

  return {
    userPhoneNumber,
    isPhoneVerified: uiIsPhoneVerified,
    verificationUIReady,
  };
};
